
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"en":{"title.offline":"Offline","connecting":"Connecting ..."},"de":{"title.offline":"Offline","connecting":"Verbinden ..."}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();